import { Add, QuestionAnswer } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setSearchValue, setSelectedItem } from 'app/actions/issue';
import { IconButton, InputSearch, Protect, Scrollbar } from 'app/components';
import { IssueDialog, IssueList } from 'app/pages/Issue';
import { useAsyncAction } from 'app/services';
import { issueLoad, issueStatusUpdate } from 'app/store/issue';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Issue = () => {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const { items, selectedItem, searchValue } = useSelector((state) => state.issue);
    const [dialogOpen, setDialogOpen] = useState(false);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(issueLoad);
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, } = useAsyncAction(issueStatusUpdate, [selectedItem]);
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleUpdateClick = () => {
        if (selectedItem) {
            updateSubmit(selectedItem.id, { okdesk_id: selectedItem.okdesk_id });
        }
    };
    const handleIssueSearchChange = (value) => dispatch(setSearchValue(value));
    useEffect(() => {
        fetchData();
        return () => {
            dispatch(setSelectedItem(null));
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '500px',
                height: '100%',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
            }) },
            !isFetchLoading && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(InputSearch, { placeholder: '\u0422\u0435\u043C\u0430 \u0437\u0430\u044F\u0432\u043A\u0438', value: searchValue, onChange: handleIssueSearchChange }),
                    React.createElement(Protect, { permissions: ['read', 'create'], renderPermitted: () => (React.createElement(React.Fragment, null,
                            React.createElement(IconButton, { onClick: handleDialogOpen, endIcon: React.createElement(Add, null) }),
                            React.createElement(IssueDialog, { open: dialogOpen, onClose: handleDialogClose }))), renderForbidden: () => React.createElement(React.Fragment, null) })),
                items.length !== 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                        flex: '1 1 auto',
                        overflow: 'hidden',
                    } },
                    React.createElement(IssueList, null))))),
            !isFetchLoading && items.length === 0 && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432\u0430\u0448\u0438 \u0437\u0430\u044F\u0432\u043A\u0438"))),
            isFetchLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(CircularProgress, { size: 24 })))),
        React.createElement(Stack, { direction: 'column', sx: {
                height: '100%',
                flex: '1 1 auto',
            } },
            selectedItem && (React.createElement(Scrollbar, null,
                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                        maxWidth: '540px',
                        margin: 'auto',
                        width: '100%',
                        padding: theme.spacing(4, 2),
                    }) },
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            marginBottom: theme.spacing(3),
                            '.MuiAvatar-root': {
                                width: '56px',
                                height: '56px',
                                bgcolor: theme.palette.primary.main,
                            },
                            '.MuiAvatar-circular': {
                                bgcolor: alpha(theme.palette.primary.main, 0.12),
                            },
                            '.MuiTypography-root:first-of-type': {
                                marginTop: theme.spacing(1),
                            },
                        }) },
                        React.createElement(Avatar, null,
                            React.createElement(QuestionAnswer, { sx: {
                                    color: selectedItem.status_color,
                                } })),
                        React.createElement(Typography, { variant: 'body1' }, selectedItem.title)),
                    React.createElement(Stack, { direction: 'column', alignItems: 'left', sx: (theme) => ({
                            width: '100%',
                            position: 'relative',
                            padding: theme.spacing(2),
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            form: {
                                width: '100%',
                            },
                        }) },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                paddingBottom: theme.spacing(1),
                                '.MuiTypography-h6': {
                                    fontSize: '1rem',
                                },
                                '.MuiTypography-caption': {
                                    color: theme.palette.text.secondary,
                                },
                            }) },
                            React.createElement(Typography, { variant: 'h6' }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                            React.createElement(Typography, { variant: 'caption' }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0437\u0430\u044F\u0432\u043A\u0435 \u0438 \u0435\u0435 \u0441\u0442\u0430\u0442\u0443\u0441")),
                        React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                                display: 'grid',
                                gap: 2,
                                '.MuiPaper-root': {
                                    position: 'relative',
                                    border: 'none',
                                },
                                '.MuiPaper-row': {
                                    display: 'grid',
                                    gap: 1,
                                    marginTop: '5px',
                                    fontSize: '13px',
                                    gridTemplateColumns: 'repeat(7, 1fr)',
                                    '.MuiTypography-root:first-of-type': {
                                        color: 'text.secondary',
                                    },
                                },
                                '.MuiPaper-row p.MuiTypography-root:nth-of-type(1)': {
                                    gridRow: '1',
                                    gridColumn: '1/3',
                                },
                                '.MuiPaper-row p.MuiTypography-root:nth-of-type(2), .MuiPaper-row div': {
                                    gridRow: '1',
                                    gridColumn: '3/8',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    'span:nth-of-type(2)': {
                                        paddingLeft: theme.spacing(0.5),
                                    },
                                },
                            }) },
                            React.createElement(Paper, { variant: 'outlined', sx: (theme) => ({
                                    marginTop: theme.spacing(1.5),
                                }) },
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0421\u043E\u0437\u0434\u0430\u043D\u0430"),
                                    React.createElement(Typography, { variant: 'body1' }, moment(selectedItem.created_at).format('YY.MM.DD HH:mm'))),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0422\u0435\u043C\u0430"),
                                    React.createElement(Typography, { variant: 'body1' }, selectedItem.title)),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u041D\u043E\u043C\u0435\u0440 \u0422\u0421"),
                                    React.createElement(Typography, { variant: 'body1' }, selectedItem.transport_number)),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"),
                                    React.createElement(Typography, { variant: 'body1' }, selectedItem.description)),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                                    React.createElement(Typography, { variant: 'body1' }, selectedItem.status)),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438"),
                                    ((_b = (_a = selectedItem.comments) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) !== 0 && (React.createElement(Typography, { component: 'div', sx: {
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            '.MuiTypography-root': {
                                                color: '#000000 !important',
                                            },
                                        } }, ((_c = selectedItem.comments) !== null && _c !== void 0 ? _c : []).map((comment, key) => (React.createElement(Typography, { key: key, variant: 'body1' }, comment)))))))),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(2),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            !isUpdateLoading && isUpdateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                            !isUpdateLoading && isUpdateSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0421\u0442\u0430\u0442\u0443\u0441 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D.")),
                        React.createElement(Protect, { permissions: ['read', 'create'], renderPermitted: () => (React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                    width: '100%',
                                    paddingTop: theme.spacing(3),
                                }) }, selectedItem.status_code !== 'closed' && (React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: handleUpdateClick, disableElevation: true }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441")))), renderForbidden: () => React.createElement(React.Fragment, null) }))))),
            !selectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    height: '100%',
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                        borderRadius: '20px',
                        marginTop: '24px',
                        padding: theme.spacing(0.5, 2),
                        bgcolor: alpha(theme.palette.grey.main, 0.12),
                    },
                }) },
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u0430\u044F\u0432\u043A\u0443 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"))))));
};
export default Issue;
